import { useState } from 'react';
import { Modal } from '@evaneos/b2b-ui/legacy';
import { Divider } from '@evaneos/b2b-ui';
import { FormattedMessage } from 'react-intl';

import { InfoOutlined } from '../../../../design-system/Icons/InfoOutlined';
import { LOST_STEP } from '../../../../domain';
import { useGetTrackedTripProperties, useTrackEventAmplitude } from '../../../../shared/analytics';
import { useGetDossierData } from '../../../../resources/dossier/queries';
import { useChangeStepMutation } from '../../../../resources/dossier/mutations';
import { DossierId } from '../../../../resources/dossier/types';

import { ModalContent } from './ModalContent';

import style from './ABMatLatency_Insight.css';

export const ABMatLatency_Insight = ({ dossierId }: { dossierId: DossierId }) => {
    const { trackEvent } = useTrackEventAmplitude();
    const [openedModal, setOpenedModal] = useState<boolean>(false);
    const trackedTripProperties = useGetTrackedTripProperties(dossierId);

    const changeStepMutation = useChangeStepMutation();
    const { step: currentStep } = useGetDossierData(dossierId)?.dossier || {};

    function lost(): void {
        if (!currentStep) return;
        changeStepMutation.mutate({ dossierId, nextStep: LOST_STEP });
        setOpenedModal(false);

        trackEvent((ampli, defaultProperties) => {
            ampli.markTheFileAsLostSubmitted({
                ...defaultProperties,
                ...trackedTripProperties,
                maturity_latence: true,
            });
        });
    }

    return (
        <>
            <Divider sx={{ margin: '32px 0 20px 0' }} />
            <div className={style.insightWrapper}>
                <div className={style.messageContainer}>
                    <div className={style.titleContainer}>
                        <InfoOutlined color="#0D8DF2" className={style.infoIcon} />
                        <h4 className={style.title}>
                            <FormattedMessage id="experiment.maturity.latency.insight.sentence1" />
                        </h4>
                    </div>
                    <ul className={style.observationMessage}>
                        <li>
                            <FormattedMessage id="experiment.maturity.latency.insight.sentence2" />
                        </li>
                        <li>
                            <FormattedMessage id="experiment.maturity.latency.insight.sentence3" />{' '}
                            <span onClick={() => setOpenedModal(true)} className={style.lostButton}>
                                <FormattedMessage id="experiment.maturity.latency.insight.sentence4" />
                            </span>
                        </li>
                    </ul>
                </div>
            </div>
            <Modal
                isOpen={openedModal !== false}
                className={style.modalContent}
                mainButton={<></>}
                title={''}
            >
                <ModalContent
                    buttonAction={lost}
                    data-testid={`modal-${LOST_STEP}`}
                    onClose={() => setOpenedModal(false)}
                    type={LOST_STEP}
                />
            </Modal>
        </>
    );
};
